<template>
    <div class="">
        <div class="w-1200" style="padding-bottom: 60px;">
            <div class="font-24 font-500 mt-8">产品目录</div>
            <div class="mt-8" style="width: 1200px;height: 10px;background: #F7F9FA;"></div>
            <div class="flex flex-wrap">
                <div class="mt-8 item" @click="$fn.toPage(item.file_url)" v-for="item in productCatalog.data"
                     :key="item.id">
                    <img :src="item.pic" width="240" height="320" alt="">
                    <div class="text-center">{{item.title}}</div>
                </div>
            </div>
            <div class="flex flex-j-c">
                <el-pagination
                        class="mt-50"
                        :page-size="16"
                        background
                        layout="prev, pager, next"
                        @current-change="getProductCatalog"
                        :total="productCatalog.total">
                </el-pagination>
            </div>

        </div>


    </div>
</template>

<script>

    import pdf from 'vue-pdf'


    export default {
        name: 'productCatalog',
        components: {
            pdf
        },
        data() {
            return {
                productCatalog: {}
            }
        },
        mounted() {
            this.getProductCatalog()
        },
        methods: {
            async getProductCatalog(page = 1) {
                this.productCatalog = await this.$api.getProductCatalog({page: page})
            },
            toPage(src) {
                this.active = src
                this.$router.push(src)
            }
        },

    }
</script>
<style scoped lang="scss">
    .item {
        padding-right: 80px;

        &:nth-child(4n+4) {
            padding-right: 0;
        }
    }
</style>
